import { Component, ViewEncapsulation } from '@angular/core';
import { CardComponent } from '../card/card.component';

@Component({
  selector: 'card-contact',
  templateUrl: './card-contact.component.html',
  styleUrls: ['./card-contact.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class CardContactComponent extends CardComponent {}